import { apiClient } from './client';

export interface CrmUser {
  id:            string;
  email:         string;
  full_name:     string;
  role:          'admin' | 'user';
  is_active:     boolean;
  last_login_at: string | null;
  created_at:    string;
  updated_at:    string;
}

export interface CreateUserInput {
  email:     string;
  full_name: string;
  role:      'admin' | 'user';
  password:  string;
}

export async function getUsers(): Promise<CrmUser[]> {
  const res = await apiClient.get<CrmUser[]>('/users');
  return res.data;
}

export async function createUser(input: CreateUserInput): Promise<CrmUser> {
  const res = await apiClient.post<CrmUser>('/users', input);
  return res.data;
}

export async function updateUser(id: string, input: Partial<Pick<CrmUser, 'full_name' | 'role' | 'is_active'>>): Promise<CrmUser> {
  const res = await apiClient.put<CrmUser>(`/users/${id}`, input);
  return res.data;
}

export async function resetUserPassword(id: string, newPassword: string): Promise<void> {
  await apiClient.put(`/users/${id}/reset-password`, { new_password: newPassword });
}

export async function deleteUser(id: string): Promise<void> {
  await apiClient.delete(`/users/${id}`);
}
